<template>
<!-- 实训中心-数据标注-实训模型 -->
  <div class="training-model">
    <gat-head class="courseDetails-head"></gat-head>
    <div class="training-model-head-content">
      <div class="training-model-head">
        <div class="head-left">
          <span class="back-span" @click="onBack"><i class="el-icon-arrow-left"></i>退出</span>
          <span class="delent-span" v-if="teacherOrStudentState && !taskId" @click="onDelent">删除</span>
        </div>
        <div class="head-right" v-if="teacherOrStudentState">
          <div v-if="taskId">
            <el-button type="primary" class="head-right-button" v-if="scoreShow" @click="onScore">实训报告</el-button>
            <el-button type="primary" class="head-right-button" v-else @click="onScore">评分</el-button>
          </div>
          <div v-else>
            <span class="release-span" v-if="releaseStatus" @click="onNoRelease">撤销发布</span>
            <span class="release-span" v-else @click="onRelease"><i class="icon-release"></i>发布</span>
          </div>
        </div>
        <div class="head-right" v-else>
          <el-button type="primary" class="head-right-button" v-if="submitShow" @click="onScoreStudent">实训报告</el-button>
          <el-button type="primary" class="head-right-button" v-else @click="onSubmitSolution">提交解法</el-button>
          <el-button 
            type="primary"
            :class="['head-right-button', {'events-disable': !scoreShow}]"
            @click="onSolution"
          >{{!solutionShow ? '项目解法':'我的解法'}}</el-button>
        </div>
      </div>
      <div class="line"></div>
      <div class="training-model-content">
        <!-- 实训步骤导航栏 -->
        <ul class="nav-ul">
          <li
            v-for="(item, index) in navList"
            :key="item.navId"
            @click="onClickNav(item.navId)"
          >
            <span :class="['li-span', navTypeStep > item.navId ? 'complete-nav-step':'', navType==item.navId ? 'select-nav':'']">
              <i :class="['icon-dot', {'site-icon-dot': navTypeStep == item.navId}]"></i>
              <span :class="[navTypeStep == item.navId ? 'site-text':'']">{{item.navName}}</span>
            </span>
            <span 
              :class="['icon-line']"
              v-if="index+1 < navList.length"
            ></span>
          </li>
          <div class=".css"></div>
        </ul>

        <div class="content">
          <!-- 创建数据集 -->
          <TrainingStepCreate
            v-if="navType == 1"
            :navType="navType"
            :Dataset="Dataset"
            @createDataset="createDataset"
            :releaseStatus="releaseStatus"
            :withdrawReleaseStatus="withdrawReleaseStatus"
            :teacherOrStudentState="teacherOrStudentState"
          ></TrainingStepCreate>

          <!-- 数据分类 -->
          <!-- 图片分类、文本分类、音频分类 -->
          <TrainingStepClassification
            v-if="navType == 2 && (modelType == 1 || modelType == 3 || modelType == 5)"
            :trainingId="trainingId"
            :modelType="modelType"
            :datasetOptions="datasetOptions"
            :datasetStatus="datasetStatus"
            :modelLimitButtonShow="modelLimitButtonShow"
            @getDatasetStatus="getDatasetStatusByDatasetId"
            :targetFileList="targetFileList"
            @getTargetFileByTraining="getTargetFileByTraining"
            :teacherOrStudentState="teacherOrStudentState"
            :releaseStatus="releaseStatus"
          ></TrainingStepClassification>
          <!-- 物体检测 -->
          <TrainingStepImageAnnotation
            v-if="navType == 2 && modelType == 2"
            :trainingId="trainingId"
            :modelType="modelType"
            :datasetOptions="datasetOptions"
            :datasetStatus="datasetStatus"
            :modelLimitButtonShow="modelLimitButtonShow"
            @getDatasetStatus="getDatasetStatusByDatasetId"
            :targetFileList="targetFileList"
            @getTargetFileByTraining="getTargetFileByTraining"
            :teacherOrStudentState="teacherOrStudentState"
            :releaseStatus="releaseStatus"
          ></TrainingStepImageAnnotation>
          <!-- 文本标注 -->
          <TrainingStepTextAnnotation
            v-if="navType == 2 && modelType == 4"
            :trainingId="trainingId"
            :modelType="modelType"
            :datasetOptions="datasetOptions"
            :datasetStatus="datasetStatus"
            :modelLimitButtonShow="modelLimitButtonShow"
            @getDatasetStatus="getDatasetStatusByDatasetId"
            :targetFileList="targetFileList"
            @getTargetFileByTraining="getTargetFileByTraining"
            :teacherOrStudentState="teacherOrStudentState"
            :releaseStatus="releaseStatus"
          ></TrainingStepTextAnnotation>

          <!-- 创建模型 -->
          <TrainingStepCreate
            v-if="navType == 3"
            :navType="navType"
            :Dataset="Dataset"
            @createDataset="createDataset"
            :releaseStatus="releaseStatus"
            :withdrawReleaseStatus="withdrawReleaseStatus"
            :teacherOrStudentState="teacherOrStudentState"
          ></TrainingStepCreate>

          <!-- 训练模型 -->
          <TrainingStepModelTrain
            v-if="navType == 4"
            :trainingId="trainingId"
            :navType="navType"
            :modelType="modelType"
            :modelOptions="modelOptions"
            :datasetOptions="datasetOptions"
            :modelInformation="modelInformation"
            :modelLimitButtonShow="modelLimitButtonShow"
            @getTrainModelByModelId="getTrainModelByModelId"
            @toModelTrain="toModelTrain"
            :releaseStatus="releaseStatus"
            :trainModelShow="trainModelShow"
            :quoteModelNum="quoteModelNum"
            @getQuoteModelNum="getQuoteCountByTrainingId"
            :withdrawReleaseStatus="withdrawReleaseStatus"
            :teacherOrStudentState="teacherOrStudentState"
          ></TrainingStepModelTrain>

          <!-- 校验模型 -->
          <TrainingStepModelVerify
            v-if="navType == 5"
            :navType="navType"
            :modelType="modelType"
            :modelOptions="modelOptions"
            :versionOptions="versionOptions"
            @toModelRelease="toModelRelease"
            :teacherOrStudentState="teacherOrStudentState"
            :releaseStatus="releaseStatus"
            :targetFileList="targetFileList"
            :targetFileShow="targetFileShow"
          ></TrainingStepModelVerify>

          <!-- 发布模型 -->
          <TrainingStepModelRelease
            v-if="navType == 6"
            :trainingId="trainingId"
            :navType="navType"
            :modelType="modelType"
            :modelOptions="modelOptions"
            :versionOptions="versionOptions"
            :modelInformation="modelInformation"
            @getTrainModelByModelId="getTrainModelByModelId"
            @toModelTrain="toModelTrain"
            :releaseStatus="releaseStatus"
            :trainModelShow="trainModelShow"
            :quoteModelNum="quoteModelNum"
            @getQuoteModelNum="getQuoteCountByTrainingId"
            :withdrawReleaseStatus="withdrawReleaseStatus"
            :teacherOrStudentState="teacherOrStudentState"
          ></TrainingStepModelRelease>
        </div>
      </div>
    </div>

    <mark-center-right
      :curriculumId="curriculumId"
      :modelType="modelType"
      :trainingDetails="trainingDetails"
      :cancelPopupShow="cancelPopupShow"
      :teacherOrStudentState="teacherOrStudentState"
      @editeProject="editeProject"
      @getTrainingByTraining="getTrainingByTraining"
      :trainModelShow="trainModelShow"
      :withdrawReleaseStatus="withdrawReleaseStatus"
    ></mark-center-right>

    <!-- 弹窗 -->
    <div class="popup-list">
      <!-- 学生提交作业确认弹窗 -->
      <gat-popup
        :class="['popup-delete popup-delete-2', popupActive === 'submitAssignment' ? 'on' : 'off']"
        :title="''"
        @cancel="cancelPopup"
        @confirm="confirmSubmitAssignment"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <!-- <div class="head">
              <i class="icon-box">
                <icon-base class="icon-info-help" :icon-name="Icons.InfoHelp.iconName" v-bind="Icons.InfoHelp">
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">提交后不能修改，是否确定提交？</span>
            </div> -->
            <div class="content">提交后不能修改，是否确定提交？</div>
          </div>
        </template>
      </gat-popup>

      <!-- 评分弹窗 -->
      <PopupScore
        ref="popupScore"
        :modelType="modelType"
        :ProjectData="Project"
        :popupActive="popupActive"
        :teacherOrStudentState="teacherOrStudentState"
        :submitShow="submitShow"
        :scoreShow="scoreShow"
        :trainingId="trainingId"
        @cancelPopup="cancelPopup"
        @UpdateScore="UpdateScore"
        :teacherId="trainingDetails.createBy"
      ></PopupScore>

      <!-- 删除弹窗- 删除项目 -->
      <PopupDeleteBox
        :deleteData="deleteData"
        :popupActive="popupActive"
        @confirmPopup="confirmPopup"
        @cancelPopup="cancelPopup"
      ></PopupDeleteBox>
    </div>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'; // 项目标注接口
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'; // 实训目录接口

import GatPopup from '@/components/common/GatPopup';
import IconInfoHelp from '@/components/icons/typography/InfoHelp';
import PopupDeleteBox from '@/components/common/PopupDeleteBox';
import PopupScore from './components/PopupScore';
import MarkCenterRight from './MarkCenterRight.vue';
import TrainingStepCreate from './TrainingStepCreate.vue'; // 创建数据集/创建模型(实训步骤1、3)
import TrainingStepClassification from './TrainingStepClassification.vue'; // 图片分类/文本分类/音频分类(实训步骤2)
import TrainingStepImageAnnotation from './TrainingStepImageAnnotation.vue'; // 物体检测(实训步骤2)
import TrainingStepTextAnnotation from './TrainingStepTextAnnotation.vue'; // 文本标注(实训步骤2)
import TrainingStepModelTrain from './TrainingStepModelTrain.vue'; // 模型训练(实训步骤4)
import TrainingStepModelVerify from './TrainingStepModelVerify.vue'; // 校验训练(实训步骤5)
import TrainingStepModelRelease from './TrainingStepModelRelease.vue'; // 发布模型(实训步骤6)

import { Websocket } from "@/assets/js/mixin/mixinWebsocket.js";

export default {
  name: 'training-model',
  props: {
    size: {
      type: String,
      default: ''
    },
  },
  components: {
    GatPopup,
    IconInfoHelp,
    PopupDeleteBox,
    PopupScore,
    MarkCenterRight,
    TrainingStepCreate,
    TrainingStepClassification,
    TrainingStepImageAnnotation,
    TrainingStepTextAnnotation,
    TrainingStepModelTrain,
    TrainingStepModelVerify,
    TrainingStepModelRelease,
  },
  mixins: [Websocket],
  data() {
    return {
      teacherOrStudentState: false, // 获取用户身份（老师-true/学生-false）
      trainingType: '', // 实训项目类型
      curriculumId: '', // 课程id
      trainingId: '', // 实训id
      userId: null, // 用户id
      taskId: '', // 作业id
      releaseStatus: false, // 发布状态 true:已发布，false:未发布
      submitNotRelease: false, // true:已提交未发布，false:未发布
      withdrawReleaseStatus: false, // true:已发布||撤回发布，false:未发布
      trainingDetails: {}, // 实训详情
      cancelPopupShow: false, // 修改成功关闭弹窗
      popupActive: '', // 弹窗
      Project: {
        Points: '', // 技能点
        PresetGoal: '', // 预设目标
        SelfRatedScore: '', // 学生自评分数
        Score: '', // 老师评分
        Appraise: '', // 老师评语
      },
      scoreShow: false, // 老师 —— true:'实训报告',false:'实训评分'
      submitShow: false, // 学生 —— true:'已提交解法',false:'未提交解法'
      solutionShow: false, // true:'项目解法'，false:'我的解法'
      navList: [
        {
          navId: '1',
          navName: '创建数据集',
        },
        {
          navId: '2',
          navName: '图片分类',
        },
        {
          navId: '3',
          navName: '创建模型',
        },
        {
          navId: '4',
          navName: '训练模型',
        },
        {
          navId: '5',
          navName: '校验模型',
        },
        {
          navId: '6',
          navName: '发布模型',
        },
      ],
      typeNameList: ['图片分类', '标注数据', '文本分类', '文本标注', '音频分类', '音频标注'],
      modelType: '1',
      navTypeStep: '1',
      navType: '1',
      Dataset: {
        datasetId: '', // 数据集id
        datasetName: '', // 数据集名称
        datasetContent: '', // 数据集详情
        modelId: '', // 模型集id
        modelName: '', // 模型名称
        modelContent: '', // 模型详情
      },
      datasetOptions: [], // 数据集列表
      datasetStatus: '', // 数据集状态
      modelOptions: [], // 模型列表
      versionOptions: [], // 训练模型列表
      Icons: {
        InfoHelp: {
          iconName: "",
          viewBox: "0 0 36 36",
          width: "36",
          height: "36"
          // iconColor: "#fff"
        }
      },
      deleteData: {
        popupType: '1', // 1：有content内容， 2：无content内容
        popupFlag: 'delete', // 对应弹窗类型
        buttonText: '删除', // 按钮文字
        title: '确定删除该项目吗？', // 标题
        content: '删除后可在 “回收站” 恢复哦！' // 内容
      },
      modelInformation: {}, // 模型信息
      modelLimitButtonShow: false, // 根据模型限制按钮-true:有模型，false：没有模型
      trainModelShow: false, // true:已发模型，false：未模型
      targetFileList: [], // 目标文件列表
      targetFileShow: false, // 校验结果文件显示：true-显示，false-不显示（老师查看学生 / 学生查看老师）
      quoteModelNum: 0, // 引用实训模型次数
    }
  },
  //监听属性 类似于data概念
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  //监控data中的数据变化
  watch: {
    token() {
      // 初始化获取实训模型步骤
      this.getTrainingModelStep();
    },
    taskId(val) {
      if (val) {
        this.targetFileShow = true;
      } else {
        this.targetFileShow = false;
      }
    },
    solutionShow(val) {
      this.targetFileShow = val;
    },
    submitShow(val) {
      setTimeout(() => {
        this.releaseStatus = val
      }, 100);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.curriculumId = this.$route.query.curriculumId || ''; // 课程id
    this.trainingId = this.$route.query.trainingId || ''; // 实训id
    this.taskId = this.$route.query.taskId || ''; // 作业id
    this.modelType = this.$route.query.modelType || '1'; // 模型类型

    this.navList[1].navName = this.typeNameList[this.modelType - 1];

    let userRole = this.$store.state.userRole;
    // userRole: 1老师，2学生，3校管理员，4超级管理员
    if (userRole === 2) {
      this.teacherOrStudentState = false;
    } else {
      this.teacherOrStudentState = true;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 根据实训id获取实训详情\信息 + 查询(老师/学生)实训报告
    this.getTeacherOrStudentTrainingReport();

    // 初始化获取实训模型步骤
    this.getTrainingModelStep();
    let self = this;
    // let userId = this.$store.state.accountInfo.userId,
    let userId = this.userId,
      socket_basis = window.gtaAiConfig.socket_basis,
      host = window.location.host,
      // wsUrl = `${socket_basis}${userId}`;
      wsUrl =  `${window.location.protocol === 'https:' ? 'wss':'ws'}://${host}${socket_basis}/websocket/${userId}`;
    // console.log('WebSocket地址', window.location.protocol, wsUrl)
    self.createWebSocket(wsUrl);
  },
  methods: {
    getTeacherOrStudentTrainingReport() {
      // 根据实训id获取实训详情\信息
      this.getTrainingByTrainingId().then(() => {
        if (this.taskId) { // 判断从作业进入标注页面
          let userId = this.$route.query.userId; // 作业返回的学生userId
          this.getTrainingReport(userId); // 查询实训报告
        } else {
          let userId = this.$store.state.accountInfo.userId; // 当前用户userId
          this.getTrainingReport(userId); // 查询实训报告
        }
      });
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 模型类别名称
    modelTypeText(type) {
      if (type == 1 || type == 3 || type == 5) {
        return `${this.modelTypeCompany(type)}分类`;
      } else if (type == 2) {
        return '标注数据';
      } else if (type == 4 || type == 6) {
        return `${this.modelTypeCompany(type)}标注`;
      }
    },
    // 初始化获取实训模型步骤
    getTrainingModelStep() {
      // 通过实训id获取数据集信息
      this.getDatasetByTrainingId().then(() => {
        // 获取目标文件列表---通过数据集id获取数据集状态
        this.getTargetFileByTraining().then(() => {
          // 通过数据集id获取数据集状态
          this.getDatasetStatusByDatasetId().then(() => {
            // 获取模型
            this.getModelByTrainingId().then(() => {
              //查询训练模型版本信息
              this.getTrainModelByModelId().then(() => {});
            });
          });
        });
      });
    },
    // 退出
    onBack() {
      this.$router.go(-1);
    },
    // 删除
    onDelent() {
      this.getQuoteCountByTrainingId();
      this.popupActive = 'delete';
    },
    // 查询实训项目被引用的实训模型
    getQuoteCountByTrainingId() {
      let data = {
        trainingId: this.trainingId
      }
      this.quoteModelNum = 0; // 默认初始删除提示
      PROJECTS.getQuoteCountByTrainingId(data).then((result) => {
        if (result.isSuccess) {
          this.quoteModelNum = result.data;
          this.deleteData.content = this.quoteModelNum != 0 ? `该实训项目已被${this.quoteModelNum}个项目引用，删除后可在“回收站”恢复哦！` : '删除后可在“回收站”恢复哦！';
        }
      })
    },
    // 确认删除
    confirmPopup(type) {
      // 确认删除项目
      if (type == 'delete') {
        let data = {
          trainingId: this.trainingId,
        };
        PROJECTS.deleteTraining(data).then((result) => {
          if (result.isSuccess) {
            this.$message.success('删除成功！');
            this.cancelPopup();
            this.$router.go(-1);
          } else {
            this.$message.success(result.returnMsg);
          }
        })
      }

    },
    // 获取目标文件列表
    getTargetFileByTraining() {
      let data = {
        trainingId: this.trainingId, // 实训id
        editorType: this.modelType, // 类型
      };
      return new Promise((resolve2, reject2) => {
        // 请求目标文件列表
        MARKCENTER.getTargetFileByTraining(data).then((result) => {
          if (result.isSuccess) {
            this.targetFileList = result.data;
            resolve2(result.data);
          } else {
            this.targetFileList = [];
            reject2(result);
          }
          // 通过数据集id获取数据集状态
          this.getDatasetStatusByDatasetId();
        }).catch((err) => {
          this.targetFileList = [];
        })
      }).catch((e) => {})
    },
    // 发布项目
    onRelease() {
      if (this.navTypeStep <= 6) {
        return this.$message.error('请先完成所有实训步骤编辑，再重新发布！');
      }

      if (this.targetFileList.length < 1) {
        let typeName = this.modelTypeText(this.modelType);
        return this.$message.error(`请先上传${typeName}-目标校验${this.modelTypeCompany(this.modelType)}，再重新发布！`);
      }
      if (!this.releaseStatus) {
        this.confirmSubmitRelease('2');
      }
    },
    // 撤销发布
    onNoRelease() {
      this.confirmSubmitRelease('3');
    },
    // 确认发布/撤回发布
    confirmSubmitRelease(status) {
      let params = {
        type: this.trainingType, // 实训项目类型
        status: status, // 实训状态 2-发布，3-撤回发布
        trainingId: this.trainingId, // 实训id
        editorType: this.modelType,
      }
      PROJECTS.releaseTraining(params).then((result) => {
        if (result.isSuccess) {
          if (status == 2) {
            this.$message.success('发布成功！');
            this.$router.go(-1);
          } else {
            this.$message.success('撤回成功！');
          }
          // 根据实训id获取实训详情\信息
          this.getTrainingByTrainingId();
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },
    // 老师评分按钮
    onScore() {
      // assessmentScore: 设置考核评分弹窗。 score：无设置考核评分弹窗  
      this.popupActive = this.trainingDetails.isAssess == 1 ? 'assessmentScore' : 'score';
    },
    // 
    onScoreStudent() {
      if (this.scoreShow) { // 已评分
        // assessmentScore: 设置考核评分弹窗。 score：无设置考核评分弹窗  
        this.popupActive = this.trainingDetails.isAssess == 1 ? 'assessmentScore' : 'score';
      } else { // 未评分
        this.popupActive = 'score';
      }
    },
    // 学生提交解法
    onSubmitSolution() {
      if (this.navTypeStep <= 6) {
        return this.$message.error('请先完成所有实训步骤编辑，再重新提交！');
      }
      // if (this.submitShow) {
      //   return this.$message.warning('项目解法已提交，不能重复提交！');
      // }
      // 学生自评弹窗
      this.popupActive = 'score';
    },
    // 项目解法/我的解法
    onSolution() {
      this.solutionShow = !this.solutionShow;
      // 初始化获取实训模型步骤/获取数据
      this.navTypeStep = '1';
      this.navType = '1';
      this.getTrainingModelStep();
    },
 
    leavePage(data) {
      if (!data || !data.deleteTrainingId) {
        return;
      }
      let deleteTrainingId = data.deleteTrainingId,
        trainingId = this.trainingId;
      if (deleteTrainingId === trainingId && !this.teacherOrStudentState) {
        this.$message.warning("该课程实训已被撤回或删除，页面将5s后退出");
        setTimeout(() => {
          this.$router.go(-1);
        }, 5000);
      }
    },
    onClickNav(type) {
      if (this.navTypeStep < type) {
        return
      }
      this.navType = type
      if (this.navType == 1) {
        this.getDatasetByTrainingId(); // 通过实训id获取数据集信息
      } else if (this.navType == 2) {
        this.getDatasetStatusByDatasetId(); // 通过数据集id获取数据集状态
      } else if (this.navType == 3) {
        this.getModelByTrainingId(); // 获取模型
      } else if (this.navType == 4 || this.navType == 5 || this.navType == 6) {
        this.getTrainModelByModelId(); //查询训练模型版本信息
      }
    },
    userIdFun(val) {
      let userId = '';
      if (val) { // 老师查看学生作业 / 学生查看老师解法
        userId = this.$route.query.userId; // 作业返回的学生userId
      } else { // 老师/学生 查看自己的
        userId = this.$store.state.accountInfo.userId; // 当前用户userId
      }
      return userId
    },
    // 通过实训id获取数据集信息
    getDatasetByTrainingId() {
      let userId = '';
      if (this.teacherOrStudentState) { // 老师
        userId = this.userIdFun(this.taskId);
      } else {  // 学生
        userId = this.userIdFun(this.solutionShow);
      }
      let params = {
        trainingId: this.trainingId,
        userId: userId,
      }
      return new Promise((resolve, reject) => {
        MARKCENTER.getDatasetByTrainingId(params).then((result) => {
          if (result.isSuccess && result.data) {
            this.Dataset.datasetId = result.data.datasetId; // 数据集id
            this.Dataset.datasetName = result.data.datasetName; // 数据集名称
            this.Dataset.datasetContent = result.data.datasetDescribe; // 数据集内容
            this.datasetOptions = [{
              datasetName: result.data.datasetName,
              datasetId: result.data.datasetId,
            }]
            if (this.navTypeStep == '1') {
              this.navTypeStep = '2';
            }
            resolve(result.data);
          } else {
            this.Dataset.datasetId = '';
            this.Dataset.datasetName = '';
            this.Dataset.datasetContent = '';
            this.datasetOptions = [];
            reject(result);
          }
        })
      }).catch((e) => {})
    },
    // 创建数据集、模型
    createDataset(val) {
      if (!val.name || !val.content) {
        return this.$message.error("请将数据相关信息填写完整");
      }
      // 创建数据集
      if (this.navType == 1) { 
        let data = {
          datasetDescribe: val.content, // 数据集描述
          datasetName: val.name, // 数据集名称
          trainingId: this.trainingId // 实训id
        }

        MARKCENTER.addDataset(data).then(result => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.getDatasetByTrainingId(); // 通过实训id获取数据集信息
          } else {
            this.$message.error(result.returnMsg);
          }
        });
      }

      // 创建模型
      if (this.navType == 3) {
        let data = {
          modelDescribe: val.content, // 模型描述
          modelName: val.name, // 模型名称
          trainingId: this.trainingId // 实训id
        }

        MARKCENTER.insertModel(data).then(result => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.getModelByTrainingId(); // 获取模型
          } else {
            this.$message.error(result.returnMsg);
          }
        });
      }
    },
    // 通过数据集id获取数据集状态
    getDatasetStatusByDatasetId() {
      let data = {
        datasetId: this.Dataset.datasetId, // 数据集id
        editorType: this.modelType,
      }
      return new Promise((resolve2, reject2) => {
        MARKCENTER.getDatasetStatusByDatasetId(data).then((result) => {
          if (result.isSuccess && result.data) {
            this.datasetStatus = result.data.status;
            if (this.datasetStatus === '准备就绪' && this.navTypeStep == '2' && this.targetFileList.length !== 0) {
              this.navTypeStep = '3';
            }
            if (
              this.datasetStatus !== '准备就绪' && this.navTypeStep != '1'
              || this.teacherOrStudentState && this.datasetStatus !== '准备就绪' && this.targetFileList.length !== 0
              || this.datasetStatus === '准备就绪' && this.navTypeStep != '1' && this.targetFileList.length === 0
            ) {
              this.navTypeStep = '2';
            }
            resolve2(result.data);
          } else {
            this.datasetStatus = '';
            reject2(result);
          }
        })
      }).catch((e) => {})
    },
    // 获取模型
    getModelByTrainingId() {
      let userId = '';
      if (this.teacherOrStudentState) { // 老师
        userId = this.userIdFun(this.taskId);
      } else {  // 学生
        userId = this.userIdFun(this.solutionShow);
      }
      let params = {
        trainingId: this.trainingId,
        userId: userId,
      }

      return new Promise((resolve, reject) => {
        MARKCENTER.getModelByTrainingId(params).then((result) => {
          if (result.isSuccess && result.data) {
            this.Dataset.modelId = result.data.modelId; // 模型id
            this.Dataset.modelName = result.data.modelName; // 模型名称
            this.Dataset.modelContent = result.data.modelDescribe; // 模型详情
            this.modelOptions = [{
              modelName: result.data.modelName,
              modelId: result.data.modelId,
            }]
            if (this.navTypeStep == '3') {
              this.navTypeStep = '4';
            }
            resolve(result.data);
          } else {
            this.Dataset.modelId = '';
            this.Dataset.modelName = '';
            this.Dataset.modelContent = '';
            this.modelOptions = [];
            reject(result);
          }
        })
      }).catch((e) => {})
    },
    // 查询训练模型版本信息
    getTrainModelByModelId() {
      let params = {
        modelId: this.Dataset.modelId,
        editorType: this.modelType
      }

      return new Promise((resolve, reject) => {
        MARKCENTER.getTrainModelByModelId(params).then((result) => {
          if (result.isSuccess && result.data) {
            this.modelInformation = result.data;
            this.modelLimitButtonShow = true;
            this.versionOptions = []; // 重置为空
            // 训练模型状态 trainModelStatus：1:进行中;2:训练完成;3:已发布;4:已下线
            this.trainModelShow = result.data.trainModelStatus == 3 ? true : false;
            let trainModelStatus = result.data.trainModelStatus;
            if (trainModelStatus == 2 || trainModelStatus == 3) {
              this.versionOptions = [{
                datasetName: result.data.datasetName,
                algorithmId: result.data.algorithmId,
                trainModelId: result.data.trainModelId,
                trainModelStatus: trainModelStatus,
                version: 'V1'
              }]

              if (trainModelStatus == 3) {
                this.navTypeStep = '7';
              } else {
                if (this.navTypeStep == '4') {
                  this.navTypeStep = '5';
                }
              }
            }
            resolve(result.data);
          } else {
            this.modelInformation = {};
            this.modelLimitButtonShow = false;
            this.trainModelShow = false;
            reject(result);
          }
        })
      }).catch((e) => {})
    },
    // 删除模型去到训练模型
    toModelTrain() {
      this.navType = '4';
      this.navTypeStep = '4';
      this.getTrainModelByModelId(); // 查询训练模型版本信息
    },
    // 校验完成后去到发布模型
    toModelRelease() {
      if (this.navTypeStep == '5') {
        this.navTypeStep = '6';
      }
    },

    // 查询实训报告
    getTrainingReport(userId) {
      let params = {
        trainingId: this.trainingId,
        userId: userId,
      }
      MARKCENTER.getTrainingReport(params).then((result) => {
        if (result.isSuccess && result.data) {
          this.Project = {
            Points: result.data.points, // 技能点
            PresetGoal: result.data.presetGoal, // 预设目标
            SelfRatedScore: Number(result.data.selfRatedScore), // 学生自评分数
            Score: Number(result.data.score), // 老师评分
            Appraise: result.data.appraise, // 老师评语
          };

          // 判断老师是否评分
          if (result.data.score !== null) {
            this.scoreShow = true;
          } else {
            this.scoreShow = false;
          }
          // 判断学生是否提交
          if (result.data.selfRatedScore !== null) {
            this.submitShow = true;
          } else {
            this.submitShow = false;
          }
        }
      })
    },
    // 根据实训id获取实训详情\信息
    getTrainingByTrainingId() {
      let params = {
        trainingId: this.trainingId,
      };
      return new Promise((resolve, reject) => {
        PROJECTS.getTrainingByTrainingId(params).then((result) => {
          if (result.isSuccess && result.data) {
            this.trainingDetails = result.data;
            this.trainingType = result.data.type;
            if (this.teacherOrStudentState) {
              // status是否发布状态 - 0:未提交；1:已提交未发布；2:已发布；3:发布后撤回
              this.submitNotRelease = result.data.status >= 1 || false;
              this.releaseStatus = result.data.status == 2 || false;
            } else {
              this.releaseStatus = false;
            }
            if (result.data.status == 2 || result.data.status == 3) {
              this.withdrawReleaseStatus = true;
            } else {
              this.withdrawReleaseStatus = false;
            }
            resolve(result.data);
          } else {
            reject(result);
          }
        })
      }).catch((e) => {})
    },
    // 修改实训项目
    editeProject(val) {
      // 项目命名不能为空和超出限制的字符长度
      if (this.$util.checkStrNullOrTooLong.call(this, [val.ProjectName])) {
        return
      }

      let params = {
        trainingContent: val.ProjectContent,
        trainingName: val.ProjectName,
        trainingId: val.trainingId,
        type: val.ProjectType,
      }

      PROJECTS.updateTraining(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success('编辑项目成功！');
          this.getTrainingByTrainingId();
          this.cancelPopupShow = true;
          setTimeout(() => {
            this.cancelPopupShow = false;
          }, 500)
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },
    // 确认修改项目信息 更新
    getTrainingByTraining() {
      this.getTrainingByTrainingId();
    },
    // 正则检验是否为数字类型
    scoreFunction(theObj) {
      var reg = /^[0-9]+\.?[0-9]*$/;
      if (reg.test(theObj)) {
          return true;
      }
      return false;
    },
    // 通过主键进行评分（老师）
    UpdateScore(val) {
      this.Project = JSON.parse(JSON.stringify(val));
      if (this.teacherOrStudentState) {
        // 老师：给学生打分
        let scoreFlag = !this.scoreFunction(this.Project.Score)
        if (scoreFlag) {
          return this.$message.error('请填写评分！')
        }
        if (!this.Project.Appraise) {
          return this.$message.error('请完整填写评分内容！')
        }
        if (this.Project.Score > 100) {
          return this.$message.error('评分不能超过满分！')
        }
        let userId = this.$store.state.accountInfo.userId, // 当前用户userId
          params = {
            score: this.Project.Score, // 教师评分分数
            appraise: this.Project.Appraise, // 教师评语
            appraiserId: userId, // 评分人Id
            taskId: this.taskId, // 作业id
          },
          msg = { success: '评分成功！', fail: '评分失败！' };

        if (this.trainingDetails && this.trainingDetails.isAssess != 0) { // 已设置考核评分
          params.processTrueScore = this.Project.processTrueScore; // 流程考核得分
          params.datasetTrueScore = this.Project.datasetTrueScore; // 数据集考核得分
          params.labelTrueScore = this.Project.labelTrueScore; // 标签考核得分
          params.modelTrueScore = this.Project.modelTrueScore; // 模型考核得分
          params.indexTrueScore = this.Project.indexTrueScore; // 模型评估指标考核得分
          params.checkTrueScore = this.Project.checkTrueScore; // 目标校验对象的校验结果考核得分
          params.customTrueScore = this.Project.customTrueScore; // 自定义考核得分
          MARKCENTER.evaluationAssessByTeacher(params).then((res) => {
            if (res.isSuccess) {
              // let studentUserId = this.$route.query.userId; // 作业返回的学生userId
              this.$message.success(msg.success);
              this.popupActive = '';
              // this.getTrainingByTrainingId();
              // this.getTrainingReport(studentUserId);
              // 根据实训id获取实训详情\信息 + 查询(老师/学生)实训报告
              this.getTeacherOrStudentTrainingReport();
              // 老师、学生查看评分实训考核结果 
              this.$refs.popupScore.getTrainingAssessReport();
            } else {
              this.$message.error(msg.fail);
            }
          })
        } else { // 未设置考核评分
          MARKCENTER.evaluationProByTeacher(params).then((res) => {
            if (res.isSuccess) {
              // let studentUserId = this.$route.query.userId; // 作业返回的学生userId
              this.$message.success(msg.success);
              this.popupActive = '';
              // this.getTrainingByTrainingId();
              // this.getTrainingReport(studentUserId);
              // 根据实训id获取实训详情\信息 + 查询(老师/学生)实训报告
              this.getTeacherOrStudentTrainingReport();
            } else {
              this.$message.error(msg.fail);
            }
          })
        }
      } else {
        // 学生：自我评分
        let scoreFlag = !this.scoreFunction(this.Project.SelfRatedScore);
        if (!this.Project.Points || !this.Project.PresetGoal || scoreFlag) {
          return this.$message.error('请完整填写自评相关内容！');
        }
        if (this.Project.SelfRatedScore > 100) {
          return this.$message.error('评分不能超过满分！');
        }
        // 弹窗提示学生作业只能提交一次不能撤回
        this.popupActive = 'submitAssignment';
      }
    },
    // 学生确认提交作业
    confirmSubmitAssignment() {
      let params = {
          points: this.Project.Points, // 技能点
          presetGoal: this.Project.PresetGoal, // 预设目标
          selfRatedScore: this.Project.SelfRatedScore, // 学生自评分数
          trainingId: this.trainingId, // 实训id
          teacherId: this.trainingDetails.createBy, // 实训创建人id
        },
        msg = { success: '自评成功！', fail: '自评失败！' };

      MARKCENTER.saveEvaluation(params).then((res) => {
        if (res.isSuccess) {
          this.$message.success(msg.success);
          this.cancelPopup();
          // this.$router.go(-1);
          // 根据实训id获取实训详情\信息 + 查询(老师/学生)实训报告
          this.getTeacherOrStudentTrainingReport();
        } else {
          this.$message.error(msg.fail);
        }
      })
    },
    // 关闭弹窗
    cancelPopup() {
      this.popupActive = '';
    },
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="scss" scoped>
@import './TrainingModel.scss';
</style>